import CardEventList from './CardEventList';

export default CardEventList;
